module.exports = __webpack_public_path__ + "img/icon_info.6f05a703.svg";